import { Checkbox, UI } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import { HStack, Pressable, VStack } from 'native-base';
import React from 'react';

import {
  TableContent,
  TableContentItemCaptions,
} from '../../../../../../../../../components/TableContent';
import { LateralBar } from '../../../../../../../../BatchTicket/components/DynamicAsset/components/Asset/components/LateralBar';
import { useFundsAssetContext } from '../../../../../../../../BatchTicket/components/DynamicAsset/contexts/products/Funds';
import { useGlobalProductContext } from '../../../../../contexts';

import { FundsListItemTypes } from '.';

export const FundsListItemMobile: React.FC<FundsListItemTypes.Props> = ({ offer }) => {
  const { setModalOpen, setOfferSelected } = useFundsAssetContext();
  const { product, infoGetter } = useGlobalProductContext();

  const onOpenDetailsModal = () => {
    setModalOpen(true);
    setOfferSelected(offer);
  };

  const selectionInfo = infoGetter(offer, 'productId');
  const isSelected = selectionInfo?.isSelected || false;
  const handleSelect = () => {
    selectionInfo?.handleSelect?.(offer, 'productId');
  };

  const middleInfos1 = [
    {
      label: 'Gestora',
      value: (
        <VStack>
          <UI.Text color="neutral.darkest">{offer.managerName}</UI.Text>
        </VStack>
      ),
    },
    {
      label: 'Tipo',
      value: (
        <VStack>
          <UI.Text color="neutral.darkest">{offer.productCategoryNormalized}</UI.Text>
        </VStack>
      ),
    },
  ];

  const middleInfos2 = [
    {
      label: 'Rent. 12 meses',
      value: (
        <VStack>
          <UI.Text color="neutral.darkest">{offer.profitabilityTwelveMonthsNormalized}</UI.Text>
        </VStack>
      ),
    },
    {
      label: 'Taxa admin.',
      value: <UI.Text color="neutral.darkest">{offer.administrationFeeNormalized}</UI.Text>,
    },
  ];

  const middleInfos3 = [
    {
      label: 'Aplic. Inicial',
      value: <UI.Text color="neutral.darkest">{offer.participateMinimumAmount}</UI.Text>,
    },
    {
      label: 'Aplic. Mín.',
      value: <UI.Text color="neutral.darkest">{offer.applicationMinimumAmount}</UI.Text>,
    },
  ];

  return (
    <TableContent direction="row" space={0} p={0} px={Spacing['inline.xxxs']}>
      <LateralBar
        backgroundColor={product.color}
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <VStack padding={Spacing['inset.sm']} space={Spacing['stack.xxxs']} w="full">
        <HStack justifyContent="space-between" alignItems="center">
          <HStack space={Spacing['inline.xxxs']} alignItems="center">
            <Pressable onPress={onOpenDetailsModal}>
              <UI.Icon name="Info" size="xs" />
            </Pressable>
            <VStack space={Spacing['stack.quarck']}>
              <UI.Text variant="semibold" color="neutral.darkest">
                {offer.productNameNormalized}
              </UI.Text>
              <TableContentItemCaptions icons={offer.captions} />
            </VStack>
          </HStack>
          <Checkbox
            testId={`checkbox-fund-${offer.productId}`}
            options={[{ label: '', value: offer?.productId?.toString() || '' }]}
            selectedValues={isSelected ? [offer?.productId?.toString() || ''] : []}
            onChange={handleSelect}
            optionPadding={{ bottom: 0, right: 0 }}
          />
        </HStack>
        <HStack justifyContent="space-between">
          {middleInfos1.map(({ label, value }) => (
            <VStack space={Spacing['stack.quarck']} key={label} w="1/2">
              <UI.Text color="neutral.black" variant="semibold">
                {label}
              </UI.Text>
              {value}
            </VStack>
          ))}
        </HStack>
        <HStack justifyContent="space-between">
          {middleInfos2.map(({ label, value }) => (
            <VStack space={Spacing['stack.quarck']} key={label} w="1/2">
              <UI.Text color="neutral.black" variant="semibold">
                {label}
              </UI.Text>
              {value}
            </VStack>
          ))}
        </HStack>
        <HStack justifyContent="space-between">
          {middleInfos3.map(({ label, value }) => (
            <VStack space={Spacing['stack.quarck']} key={label} w="1/2">
              <UI.Text color="neutral.black" variant="semibold">
                {label}
              </UI.Text>
              {value}
            </VStack>
          ))}
        </HStack>
      </VStack>
    </TableContent>
  );
};
